import TrackClaimStepper from './TrackClaimStepper';


export default function TrackClaim(){
    return (
       
        <TrackClaimStepper />

    )
}